<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="店铺入驻" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <step :options="options" :active="3"></step>
        <div v-if="storeJoinin.joinin_state==20 || storeJoinin.joinin_state==31">
            <div v-if="storeJoinin.joinin_state==31" class="notice">{{title}}:{{message}}</div>

            <div class="content">
                <div @click="showDetail=true"><flex-line :is-link="true" :show-border="true"><span class="line-name">申请信息</span></flex-line></div>
                <flex-line :show-border="true"><span class="line-name">应付金额</span><span slot="right">{{storeJoinin.paying_amount}}元</span></flex-line>
                <flex-line :show-border="true">
                    <span>支付方式</span>
                    <div slot="right">
                        <mt-radio
                                v-model="paymentType"
                                :options="paymentTypeOption">
                        </mt-radio>
                    </div>
                </flex-line>
                <flex-line v-if="paymentType=='1'" class="pt-5" :show-border="true">
                    <span>付款凭证</span>
                    <div slot="right">
                        <div class="user-avatar-wrapper">
                            <div v-if="storeJoinin.paying_money_certificate" class="user-avatar">
                                <img :src="storeJoinin.paying_money_certificate_url" @click="openImage(storeJoinin.paying_money_certificate_url)">
                                <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
                            </div>
                            <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('paying_money_certificate',$event)">
                                <div class="center-text">相机/相册</div>
                                <input type="file" accept="image/*">
                            </div>
                        </div>
                    </div>
                </flex-line>
                <flex-line v-if="paymentType=='1'" class="field-line" :show-border="true"><span class="field-name">备注</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.paying_money_certificate_explain" /></div></flex-line>
                <div v-if="paymentType=='1'" class="payment-notice" @click="onAgreement()">不清楚平台收款账号？</div>
            </div>
            <div class="common-btn ds-button-large mt-10"  @click="nextStep">提交</div>
        </div>
        <div class="main-content" v-else>
            <img class="center-image" src="../../../assets/image/sellerjoinin_wait.jpg" />
            <div class="big-title">{{title}}</div>
            <div class="desc">{{message}}</div>
        </div>
        <div>
            <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
                <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
            </mt-popup>
        </div>
        <div>
            <mt-popup v-model="showDetail" position="right" class="common-popup-wrapper">
                <div class="common-header-wrap">
                    <mt-header title="申请信息" class="common-header">
                        <mt-button slot="left" icon="back" @click="showDetail=false"></mt-button>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                    <div class="label">公司及联系人信息</div>
                    <div class="content">
                        <flex-line :show-border="true"><span class="line-name">{{storeJoinin.store_type==1?'店铺名称':'公司名称'}}</span><span slot="right">{{storeJoinin.company_name}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">所在地</span><span slot="right">{{storeJoinin.company_address}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">详细地址</span><span slot="right">{{storeJoinin.company_address_detail}}</span></flex-line>
                        <flex-line v-if="storeJoinin.store_type==0" :show-border="true"><span class="line-name">注册资金</span><span slot="right">{{storeJoinin.company_registered_capital}}万元</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">联系人姓名</span><span slot="right">{{storeJoinin.contacts_name}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">联系人电话</span><span slot="right">{{storeJoinin.contacts_phone}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">电子邮箱</span><span slot="right">{{storeJoinin.contacts_email}}</span></flex-line>
                    </div>
                    <div class="label">营业执照信息（副本）</div>
                    <div class="content">
                        <flex-line :show-border="true"><span class="line-name">营业执照号</span><span slot="right">{{storeJoinin.business_licence_number}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">营业执照所在地</span><span slot="right">{{storeJoinin.business_licence_address}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">有效期起始</span><span slot="right">{{storeJoinin.business_licence_start}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">有效期结束</span><span slot="right">{{storeJoinin.business_licence_end}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">经营范围</span><span slot="right">{{storeJoinin.business_sphere}}</span></flex-line>
                        <flex-line class="pt-5" :show-border="true">
                            <span>营业执照电子版</span>
                            <div slot="right">
                                <div class="user-avatar-wrapper">
                                    <div class="user-avatar">
                                        <img :src="storeJoinin.business_licence_number_electronic_url" @click="openImage(storeJoinin.business_licence_number_electronic_url)">
                                    </div>
                                </div>
                            </div>
                        </flex-line>
                    </div>
                    <div v-if="storeJoinin.store_type==0">
                        <div class="label">开户银行信息</div>
                        <div class="content">
                            <flex-line :show-border="true"><span class="line-name">银行开户名</span><span slot="right">{{storeJoinin.bank_account_name}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">公司银行账号</span><span slot="right">{{storeJoinin.bank_account_number}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">银行支行名称</span><span slot="right">{{storeJoinin.bank_name}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">银行所在地</span><span slot="right">{{storeJoinin.bank_address}}</span></flex-line>
                        </div>
                        <div class="label">结算账号信息</div>
                        <div class="content">
                            <flex-line :show-border="true"><span class="line-name">银行开户名</span><span slot="right">{{storeJoinin.settlement_bank_account_name}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">公司银行账号</span><span slot="right">{{storeJoinin.settlement_bank_account_number}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">银行支行名称</span><span slot="right">{{storeJoinin.settlement_bank_name}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">银行所在地</span><span slot="right">{{storeJoinin.settlement_bank_address}}</span></flex-line>
                        </div>
                    </div>
                    <div v-else>
                        <div class="label">结算账号信息</div>
                        <div class="content">
                            <flex-line :show-border="true"><span class="line-name">支付宝姓名</span><span slot="right">{{storeJoinin.settlement_bank_account_name}}</span></flex-line>
                            <flex-line :show-border="true"><span class="line-name">支付宝账号</span><span slot="right">{{storeJoinin.settlement_bank_account_number}}</span></flex-line>
                        </div>
                    </div>
                    <div class="content">
                        <flex-line :show-border="true"><span class="line-name">商家账号</span><span slot="right">{{storeJoinin.seller_name}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">店铺名称</span><span slot="right">{{storeJoinin.store_name}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">店铺等级</span><span slot="right">{{storeJoinin.storegrade_name}}</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">开店时长</span><span slot="right">{{storeJoinin.joinin_year}}年</span></flex-line>
                        <flex-line :show-border="true"><span class="line-name">店铺分类</span><span slot="right">{{storeJoinin.storeclass_name}}</span></flex-line>
                        <div @click="showGoodsClass=true"><flex-line :is-link="true" :show-border="true"><span class="line-name">经营类目</span></flex-line></div>
                    </div>
                </div>
            </mt-popup>
            <mt-popup v-model="showGoodsClass" position="right" class="common-popup-wrapper">
                <div class="common-header-wrap">
                    <mt-header title="经营类目" class="common-header">
                        <mt-button slot="left" icon="back" @click="showGoodsClass=false"></mt-button>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                    <div class="content">
                        <div v-for="(goods_class,index) in storeJoinin.store_class_names" :key="index">
                            <flex-line :show-border="true"><span class="line-name">{{goods_class}}</span><span slot="right">{{storeJoinin.store_class_commis_rates[index]}}%</span></flex-line>
                        </div>
                    </div>
                </div>
            </mt-popup>
            <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
                <div class="common-header-wrap">
                    <mt-header title="裁剪图片" class="common-header">
                        <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
                        <div slot="right" class="common-btn btn" @click="useCrop">使用</div>
                    </mt-header>
                </div>
                <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
            </mt-popup>
        </div>
        <div>
            <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
                <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
            </mt-popup>
        </div>
    </div>
</template>
<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import Step from '../../Step'
import { getStoreJoinin, saveStoreJoinin5, uploadInfoFile } from '../../../api/seller'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    Step,
    VueCropper
  },
  data () {
    return {
        paymentType:'0',
        paymentTypeOption: [
            {
                label: '在线支付',
                value: '0'
            },
            {
                label: '线下支付',
                value: '1'
            }
        ],
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      options: [{ title: '公司资质' }, { title: '财务资质' }, { title: '店铺信息' }, { title: '合同签订' }],
      showimage: '',
      isshow: false,
      showGoodsClass: false,
      showDetail: false,
      message: '',
      title: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      storeJoinin1: state => state.member.storeJoinin1,
      storeJoinin0: state => state.member.storeJoinin0,
      storeJoininType: state => state.member.storeJoininType,
    }),
    storeJoinin:function(){
      if(this.storeJoininType==1){
        return this.storeJoinin1
      }else{
        return this.storeJoinin0
      }
    },
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }
  },
  created: function () {
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
        this.sellerJoininTypeSave({storeJoininType:store_joinin.store_type})
        if (store_joinin.joinin_state == 40) {
          Toast('您的店铺已开通')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }
        this.sellerJoininSave({ storeJoinin: store_joinin })
        if (store_joinin.joinin_state == 10) {
          this.message = '感谢您在本平台申请商家入驻'
          this.title = '正在审核中'
        } else if (store_joinin.joinin_state == 11) {
          this.title = '付款审核中'
          this.message = '请等待管理员审核打款'
        } else {
          // if (store_joinin.joinin_state == 20) {
          //   this.title = '初审成功'
          //   this.message = '应付金额' + store_joinin.paying_amount + '元'
          // } else {
          if (store_joinin.joinin_state == 30) {
            this.title = '初审失败'
          }
          if (store_joinin.joinin_state == 31) {
            this.title = '付款审核失败'
          }
          this.message = store_joinin.joinin_message
          // }
        }
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapMutations({
      sellerJoininSave: 'sellerJoininSave',
      sellerJoininTypeSave: 'sellerJoininTypeSave'
    }),
    nextStep () {
        if(this.paymentType=='1'){
            saveStoreJoinin5(this.storeJoinin).then(res => {
                this.sellerJoininSave({ storeJoinin: this.storeJoinin })
                this.storeJoinin.joinin_state = 11
                this.title = '付款审核中'
                this.message = '请等待管理员审核打款'
            }).catch(error => {
                Toast(error.message)
            })
        }else{
            this.$router.push({ name: 'MemberBuyPay', query: { pay_type: 'sj_pay' } })
        }

    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage () {
      this.storeJoinin.paying_money_certificate = ''
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        formdata.append('name', 'file')

        uploadInfoFile(formdata).then(res => {
          this.storeJoinin.paying_money_certificate = res.result.path
          this.storeJoinin.paying_money_certificate_url = res.result.url
          this.showCrop = false
          Indicator.close()
          this.$forceUpdate()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
      onAgreement () {
          this.$router.push({
              name: 'HomeDocument',
              query: { type: 'open_store' }
          })
      }
  }
}
</script>
<style  lang="scss" scoped>
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .content{background: #fff;padding:0 $pageSpace}
    .container {
        background: #fff;
    }
    .label {
        padding: .5rem;
        font-size:$subFontSize;
        background: #eee;
    }
    .notice{font-size:$subFontSize;padding:.5rem;background:#FCF8E3;color:#C09853;line-height: 1.65rem;}
    .center-image{width: 60%}
    .main-content{text-align: center;padding:2rem}
    .big-title{margin-top:2rem;margin-bottom: 1rem;}
    .desc{font-size:$h2;color:#666}
    .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
    .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
    .user-avatar {
        display: block;
        border:1px solid #eee;
        position: relative;
        width: 5rem;
        height: 5rem;
        margin: 0 auto;
        text-align: center;
        img {
            width: 100%;
            height: 100%
        }
        input {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0
        }
        .center-text{padding:.2rem;padding-top:3.5rem;font-size:$fontSize}
    }
    .user-avatar::before {
        position: absolute;
        font-size: 1.5rem;
        line-height: 5rem;
        left: 50%;
        margin-left: -.75rem;
        color: rgba(0, 0, 0, 0.5)
    }
    .payment-notice{
        font-size:$fontSize;
        color:$primaryColor;
        padding:1rem 0;
        text-align: right;
    }
</style>
